import React, { Component } from "react";
import DatePicker from "material-ui/DatePicker";
import Util from "../../common/Util";
import "./AddDateTimeRange.css";

const styles = {
	actionButton: {
		margin: 0
	},
	rangeDateField: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-around",
		padding: 10
	}
};
class DateRange extends Component {
	constructor(props) {
		super(props);
		this.state = {
			fDesde: null,
			fHasta: null,
			disabledDate: this.props.disabledDate
		};
		this.fields = null;
		this.onFechaDesdeChange = this.onFechaDesdeChange.bind(this);
		this.onFechaHastaChange = this.onFechaHastaChange.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.dateFrom && nextProps.dateTo) {
			this.setState({
				fHasta: new Date(nextProps.dateTo),
				fDesde: new Date(nextProps.dateFrom)
			});
		}
		if (nextProps.disabledDate !== this.state.disabledDate) {
			this.setState({
				disabledDate: nextProps.disabledDate
			});
		}
	}
	onFechaDesdeChange(event, date) {
		let fDesde = date;
		let fHasta = this.state.fHasta;
		if (fHasta !== null && fHasta < fDesde) {
			Util.showNoty(
				"ERROR",
				"La fecha Desde debe ser anterior a la fecha Hasta."
			);
		} else {
			this.setState({
				fDesde: date
			});
			// this.props.dispatchOnChange(this.props.dateFromField, date);
			this.props.onChangeDateField(this.props.dateFromField, date);
		}
	}
	formatDate(date) {
		//date = JSON.parse(JSON.stringify(date));
		let formatDate = Util.formatDateToShowNotHour(date);
		return formatDate;
	}

	onFechaHastaChange(event, date) {
		let fHasta = date;
		let fDesde = this.state.fDesde;
		if (fDesde !== null && fHasta < fDesde) {
			Util.showNoty(
				"ERROR",
				"La fecha Hasta debe ser posterior a la fecha Desde."
			);
		} else {
			this.setState({
				fHasta: date
			});
			// this.props.dispatchOnChange(this.props.dateToField, date);
			this.props.onChangeDateField(this.props.dateToField, date);
		}
	}
	disablePrevDates(startDate) {
		const startSeconds = Date.parse(startDate);
		return date => {
			return Date.parse(date) < startSeconds;
		};
	}
	render() {
		let props = this.props;
		return (
			<div>
				<div style={styles.rangeDateField}>
					<div style={{ width: "49%", padding: 10 }}>
						<DatePicker
							ref="fDesde"
							onChange={this.onFechaDesdeChange}
							floatingLabelText={props.labelOne}
							floatingLabelFixed={true}
							hintText="dd/mm/aaaa"
							value={this.state.fDesde}
							fullWidth={true}
							minDate={this.props.minDateValue}
							maxDate={this.props.maxDateValue}
							errorText={this.props.errorDateFrom}
							formatDate={this.formatDate}
							disabled={this.state.disabledDate}
						/>
					</div>
					<div style={{ width: "49%", padding: 10 }}>
						<DatePicker
							ref="fHasta"
							errorText={this.props.errorDateTo}
							onChange={this.onFechaHastaChange}
							floatingLabelText={props.labelTwo}
							floatingLabelFixed={true}
							hintText="dd/mm/aaaa"
							value={this.state.fHasta}
							fullWidth={true}
							shouldDisableDate={this.disablePrevDates(this.state.fDesde)}
							minDate={this.state.fDesde}
							disabled={
								!this.state.disabledDate
									? this.state.fDesde
										? false
										: true
									: true
							}
							formatDate={this.formatDate}
						/>
					</div>
				</div>
			</div>
		);
	}
}
export default DateRange;



// WEBPACK FOOTER //
// ./src/components/DateRange/DateRange.js